import React, { useEffect, useState } from "react";
import { satisfiedEmotions } from "../../assets/emotions";
import { unsatisfiedEmotions } from "../../assets/emotions";
import { mainSatisfiedEmotions } from "../../assets/emotions";
import { mainUnsatisfiedEmotions } from "../../assets/emotions";
import { mainNeeds } from "../../assets/needs";
import { needs } from "../../assets/needs";
import Request from "../Request";
import PreviewModal from "../PreviewModal";
import CompletionModal from "../CompletionModal";
import CopyToClipboard from "react-copy-to-clipboard";
import { getFullResponse } from "../../assets/getFullResponse";
import ConfettiExplosion from "react-confetti-explosion";
import "../../css/ConnectionBuilderForm.css";
import NavBar from "../NavBar";
import axios from "axios";
import Disclaimer from "../Disclaimer";

// TODO: consider a better UI for filling out the form - auto scroll?
// TODO: Improve SEO in index.html
// TODO: Auto-Save form data in localStorage

const ConnectionBuilderForm = () => {
  const [showRequest, setShowRequest] = useState(false);
  const [isExploding, setIsExploding] = useState(false);
  const [openPreviewModal, setOpenPreviewModal] = useState(false);
  const [editPreview, setEditPreview] = useState(false);
  const [openCompletionModal, setOpenCompletionModal] = useState(false);
  const [feelDefinition, setFeelDefinition] = useState("");
  const [needDefinition, setNeedDefinition] = useState("");
  const [previewBtnColor, setPreviewButtonColor] = useState({
    className: "border shadow btn btn-light",
    disabled: true,
  });
  const [requestBtnColor, setRequestButtonColor] = useState({
    className: "border shadow btn btn-light",
    disabled: true,
  });
  const [formInfo, setFormInfo] = useState({
    observeInput: "",
    feelInput: "",
    needInput: "",
    offerInput: "",
    requestInput: "",
  });
  const [finalResponse, setFinalResponse] = useState({
    previewEdit: "",
    copied: false,
  });

  // Request Button only visible if observation, feelings, needs, and offering are filled in
  useEffect(() => {
    if (
      formInfo.observeInput.length > 0 &&
      formInfo.feelInput.length > 0 &&
      formInfo.needInput.length > 0 &&
      formInfo.offerInput.length > 0
    ) {
      setRequestButtonColor({
        className: "shadow btn btn-info",
        disabled: false,
      });
    }
  }, [
    formInfo.observeInput,
    formInfo.feelInput,
    formInfo.needInput,
    formInfo.offerInput,
  ]);

  // Preview Button only visible if observation, feelings, needs, offering, and request are filled in
  useEffect(() => {
    if (
      formInfo.observeInput.length > 0 &&
      formInfo.feelInput.length > 0 &&
      formInfo.needInput.length > 0 &&
      formInfo.offerInput.length > 0
    ) {
      setPreviewButtonColor({
        className: "shadow btn btn-success",
        disabled: false,
      });
    }
  }, [
    formInfo.observeInput,
    formInfo.feelInput,
    formInfo.needInput,
    formInfo.offerInput,
    formInfo.requestInput,
  ]);

  const confettiExplosion = () => {
    setIsExploding(true);
  };

  const seePreview = (e) => {
    e.preventDefault();
    setOpenPreviewModal(!openPreviewModal);
  };

  const seeCompleteResponse = (e) => {
    e.preventDefault();
    setOpenCompletionModal(!openCompletionModal);
    confettiExplosion();
  };

  const BackToTopFunc = () => {
    window.scrollTo(0, 0);
  };

  const closePreviewModal = () => {
    setOpenPreviewModal(false);
    BackToTopFunc();
  };

  const closeCompletionModal = () => {
    setOpenCompletionModal(false);
  };

  const handleChange = (e) => {
    setFormInfo({ ...formInfo, [e.target.name]: e.target.value });
  };

  const handleDropdownChange = (input, value) => {
    setFormInfo({ ...formInfo, [input]: value });
    showDefinition(value, input);
  };

  const showRequestForm = (e) => {
    e.preventDefault();
    setShowRequest(!showRequest);
  };

  const handleEdit = (e) => {
    setFinalResponse({ ...finalResponse, [e.target.name]: e.target.value });
  };

  const showDefinition = async (word, inputType) => {
    const dictionaryApiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${word}`;

    const dictionaryObj = await axios.get(dictionaryApiUrl);

    switch (inputType) {
      case "feelInput":
        setFeelDefinition(
          dictionaryObj.data[0].meanings[0].definitions[0].definition
        );
        break;
      case "needInput":
        setNeedDefinition(
          dictionaryObj.data[0].meanings[0].definitions[0].definition
        );
        break;
      default:
        return;
    }
  };

  return (
    <div className="InitialForm container-fluid text-center">
      <NavBar />
      <h4>Nonviolent Communication Response Builder</h4>
      <small>
        - Inspired by{" "}
        <a href="https://www.cnvc.org/" target="_blank" rel="noreferrer">
          The Center For Nonviolent Communication
        </a>{" "}
        -
      </small>
      <br></br>

      <Disclaimer />

      <form
        className="form-part-1 p-2"
        onSubmit={seePreview}
        onChange={handleChange}
      >
        <div className="observe m-3 p-3">
          <h2>I observe 👁️</h2>
          <label htmlFor="observe">
            What did you notice or see? Stay as objective and factual as
            possible. <br></br>
            <strong>Do your best to avoid "you" statements here.</strong>
          </label>
          <br></br>
          <textarea
            name="observeInput"
            placeholder="I noticed... I see..."
            value={formInfo.observeInput}
            onChange={handleChange}
          ></textarea>
        </div>
        <hr></hr>

        <div className="feel m-3 p-3">
          <h2>I feel 🧠❤️</h2>
          <label htmlFor="feelInput">
            How did you feel as a result of what you described above?
          </label>
          <br></br>

          <div className="feelings-dropdown d-flex justify-content-center">
            <div className="dropdown">
              <button
                className="btn btn-info dropdown-toggle m-1"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Satisfied Feelings Inventory
              </button>

              <div
                className="dropdown-menu scrollable-menu"
                aria-labelledby="dropdownMenuButton"
                name="satisfiedFeelInput"
              >
                {/* map all the emotions from the NVC wheel,
              perhaps use the dictionary API to provide a definition of the emotion;
              consider making two separate dropdowns with satisfied and not satisfied emotions*/}
                {satisfiedEmotions.map((emotion) => {
                  if (mainSatisfiedEmotions.includes(emotion)) {
                    return (
                      <span
                        key={emotion}
                        className="dropdown-item"
                        onClick={() =>
                          handleDropdownChange("feelInput", emotion)
                        }
                      >
                        <strong>{emotion.toUpperCase()}</strong>
                      </span>
                    );
                  } else {
                    return (
                      <span
                        key={emotion}
                        className="dropdown-item"
                        onClick={() =>
                          handleDropdownChange("feelInput", emotion)
                        }
                      >
                        {emotion}
                      </span>
                    );
                  }
                })}
              </div>
            </div>

            <div className="dropdown">
              <button
                className="btn btn-info dropdown-toggle m-1"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Unsatisfied Feelings Inventory
              </button>
              <div
                className="dropdown-menu scrollable-menu"
                aria-labelledby="dropdownMenuButton"
                name="unsatisfiedFeelInput"
              >
                {/* map all the emotions from the NVC wheel,
              perhaps use the dictionary API to provide a definition of the emotion;
              consider making two separate dropdowns with satisfied and not satisfied emotions*/}
                {unsatisfiedEmotions.map((emotion) => {
                  if (mainUnsatisfiedEmotions.includes(emotion)) {
                    return (
                      <span
                        key={emotion}
                        className="dropdown-item"
                        onClick={() =>
                          handleDropdownChange("feelInput", emotion)
                        }
                      >
                        <strong>{emotion.toUpperCase()}</strong>
                      </span>
                    );
                  } else {
                    return (
                      <span
                        key={emotion}
                        className="dropdown-item"
                        onClick={() =>
                          handleDropdownChange("feelInput", emotion)
                        }
                      >
                        {emotion}
                      </span>
                    );
                  }
                })}
              </div>
            </div>
          </div>

          <div className="preview-text p-2 m-2 mt-4">
            {formInfo.feelInput.length > 0 && (
              <>
                <h5 className="mb-3">
                  As a result of what I noticed, I feel{" "}
                  <span className="selected">
                    <strong>{formInfo.feelInput}</strong>
                  </span>
                  .
                </h5>

                <div className="definition">
                  <em>
                    <strong>Definition:</strong>{" "}
                    {feelDefinition ? (
                      feelDefinition
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-hourglass-split"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
                      </svg>
                    )}
                  </em>
                </div>
              </>
            )}
          </div>
        </div>

        <hr></hr>

        <div className="need  m-3 p-3">
          <h2>I need 🤲🏽</h2>
          <label htmlFor="needInput">
            What do you need to move forward in this situation?
          </label>
          <br></br>
          <div className="dropdown">
            <button
              className="btn btn-info dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Needs Inventory
            </button>
            <div className="preview-text p-2 m-2 mt-4">
              {formInfo.needInput.length > 0 && (
                <>
                  <h5 className="mb-3">
                    In order to move forward, I need{" "}
                    <span className="selected">{formInfo.needInput}</span>.
                  </h5>

                  <div className="definition">
                    <em>
                      <strong>Definition:</strong>{" "}
                      {needDefinition ? (
                        needDefinition
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-hourglass-split"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
                        </svg>
                      )}
                    </em>
                  </div>
                </>
              )}
            </div>
            <div
              className="dropdown-menu scrollable-menu"
              aria-labelledby="dropdownMenuButton"
              name="needInput"
            >
              {/* map all the emotions from the NVC wheel,
              perhaps use the dictionary API to provide a definition of the emotion */}
              {needs.map((need) => {
                if (mainNeeds.includes(need)) {
                  return (
                    <span
                      key={need}
                      className="dropdown-item"
                      value={need}
                      onClick={() => handleDropdownChange("needInput", need)}
                    >
                      <strong>{need.toUpperCase()}</strong>
                    </span>
                  );
                } else {
                  return (
                    <span
                      key={need}
                      className="dropdown-item"
                      value={need}
                      onClick={() => handleDropdownChange("needInput", need)}
                    >
                      {need}
                    </span>
                  );
                }
              })}
            </div>
          </div>
        </div>
        <hr></hr>

        <div className="offer m-3 p-3">
          <h2>I offer 🎁</h2>
          <label htmlFor="offer">
            What are you willing to do or offer to the situation to help all
            parties move forward?<br></br>
            Be honest and mindful about your capacity and what you are willing
            to do/give. <br></br>
            <strong>
              Only offer what feels authentic to you and the situation.
            </strong>
          </label>
          <br></br>
          <textarea
            name="offerInput"
            placeholder="I am willing to... I am comfortable with..."
            value={formInfo.offerInput}
            onChange={handleChange}
          ></textarea>

          <br></br>
          <small>
            Note: This section is not part of the original NVC steps, but was
            added as a way to provide more personal accountability in building
            your response.
          </small>
        </div>
        <hr></hr>

        <div className="request  m-3 p-3">
          <h2>I request 🤝🏽</h2>
          <button
            onClick={showRequestForm}
            type="button"
            className={requestBtnColor.className}
            disabled={requestBtnColor.disabled}
          >
            Make a request ✅
          </button>

          {showRequest && (
            <Request handleChange={handleChange} formInfo={formInfo} />
          )}
          <br></br>
        </div>
        <hr></hr>

        <div className="preview m-4">
          <button
            type="submit"
            className={previewBtnColor.className}
            disabled={previewBtnColor.disabled}
            onClick={() =>
              setFinalResponse({ previewEdit: getFullResponse(formInfo) })
            }
          >
            Preview Response 😎
          </button>
        </div>
      </form>

      <PreviewModal open={openPreviewModal} close={closePreviewModal}>
        <div className="previewText text-center">
          <h3>Preview 👀</h3>
          {editPreview ? (
            <textarea
              name="previewEdit"
              value={finalResponse.previewEdit}
              onChange={handleEdit}
              className="previewEdit"
            ></textarea>
          ) : (
            <div className="previewEditText m-3">
              {finalResponse.previewEdit}
            </div>
          )}
        </div>

        <div className="d-flex justify-content-center">
          {editPreview ? (
            <button
              onClick={() => setEditPreview(!editPreview)}
              type="button"
              className="btn btn-warning mt-4 m-2"
            >
              Finish ✅
            </button>
          ) : (
            <button
              onClick={() => {
                setFinalResponse({ previewEdit: getFullResponse(formInfo) });
                setEditPreview(!editPreview);
              }}
              type="button"
              className="btn btn-warning mt-4 m-2"
            >
              Edit 📝
            </button>
          )}

          <CopyToClipboard
            text={finalResponse.previewEdit}
            onCopy={() => setFinalResponse({ ...finalResponse, copied: true })}
          >
            <button
              onClick={seeCompleteResponse}
              type="button"
              className="btn btn-success mt-4 m-2"
            >
              Copy Response 📋
            </button>
          </CopyToClipboard>
        </div>

        <CompletionModal
          open={openCompletionModal}
          closeCompletion={closeCompletionModal}
          closePreview={closePreviewModal}
          setFormInfo={setFormInfo}
          isExploding={isExploding}
        >
          <div className="completion-modal text-center">
            {isExploding && <ConfettiExplosion particleCount={250} />}
            <h2>👏🏽 🎉 👁️ 🧠 ❤️ 🤲🏽 🎁</h2>
            <h2>Congratulations!</h2>
            <h6>You have chosen a non-violent communication approach.</h6>
            <hr></hr>

            <div className="final-response">
              <h5>Your Work ✉️</h5>
              {finalResponse.previewEdit}
            </div>

            <hr></hr>

            <h6>
              I hope you found this tool useful while processing your feelings
              and needs.
            </h6>

            <h6>
              It is my hope you find clarity within the situations you may find
              yourself.
            </h6>

            <img
              src="https://i.imgur.com/c3BxWIY.gif"
              alt="geometric breathing gif"
            ></img>

            <h6>Enjoyed building your response?</h6>
            <h6>Say Thanks with a Coffee! ☕️ || Venmo: @dakotafabro</h6>
            <hr></hr>

            <div className="m-2 mt-4">
              You can learn more about Non-Violent Communication{" "}
              <a
                className="nvc-link"
                href="https://www.cnvc.org/"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
              .
            </div>

            <button
              className="btn btn-info"
              onClick={() => {
                closeCompletionModal();
                closePreviewModal();
                setFormInfo({
                  observeInput: "",
                  feelInput: "",
                  needInput: "",
                  offerInput: "",
                  requestInput: "",
                });
              }}
            >
              Build Another Response
            </button>
          </div>
        </CompletionModal>
      </PreviewModal>
    </div>
  );
};

export default ConnectionBuilderForm;
